import React from 'react';
import './itemWithImage.css'
import { Link, useRouteMatch } from "react-router-dom";
import { classNames } from '../../utils/classNames';

export function ItemWithImage(props: {
    src?: string,
    children?: JSX.Element | JSX.Element[] | string,
    className?: string,
    to?: string,
    imgWith?: number,
    imgHeight?: number
}) {
    let { url } = useRouteMatch();
    return (
        <Link
            className={classNames("item-with-image", props.className)}
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            to={`${url}${props.to}`}
        >
            <img src={props.src} width={props.imgWith} height={props.imgHeight} alt={props.src} />
            <div>
                {props.children}
            </div>
        </Link>
    )
}

export function ItemWithImage2(props: {
    src?: string,
    children?: JSX.Element | JSX.Element[] | string,
    className?: string,
    to?: string,
    imgWith?: number,
    imgHeight?: number
}) {
    let { url } = useRouteMatch();
    return (
        <Link
            className={classNames("item-with-image", props.className)}
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            to={props.to || url}
        >
            <img src={props.src} width={props.imgWith} height={props.imgHeight} alt={props.src} />
            <div>
                {props.children}
            </div>
        </Link>
    )
}